module.exports = __webpack_public_path__ + "static/media/location.ed93d0fe.svg";